// extracted by mini-css-extract-plugin
export default {"intro-main":"UserIntroPrompt_intro-main__EWLui","cross":"UserIntroPrompt_cross__k5N4k"};